const swiperHomeSocial = new Swiper(".swiper-social", {
  loop: true,
  slidesPerView: "auto",
  slidesPerGroup: 1,
  spaceBetween: 8,

  breakpoints: {
    768: {
      spaceBetween: 28,
    },
  },

  //   pagination: {
  //     el: ".swiper-pagination",
  //   },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-next-soc",
    prevEl: ".swiper-prev-soc",
  },
});
